// extracted by mini-css-extract-plugin
module.exports = {"ErrorBoundary":"by0Lt"};